import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicInput, BaasicFormControls, BasicFieldCheckbox, BaasicFieldDropdown} from 'core/components';

function GenerateTemplate({generateStore}) {
    const {
        generateForm,
        facilityStore,
    } = generateStore;

    return (
        <form onSubmit={generateForm.onSubmit}>
            <div className="modal__header">
                <h3 className='modal__header__title'>Generate Dates</h3>
            </div>
            <div className='modal__body'>
                <div className="form__group">
                    <BaasicFieldDropdown field={generateForm.$('facilityId')} store={facilityStore} />
                </div>
                <div className="row">
                    <div className="form__group col col-sml-12 col-med-6">
                            <BasicInput field={generateForm.$('startDate')} />
                    </div>
                    <div className="form__group col col-sml-12 col-med-6">
                        <BasicInput field={generateForm.$('endDate')} />
                    </div>
                        {/* <div className="daterange__input">
                            <DateRangePickerField fromField={generateForm.$('startDate')} toField={generateForm.$('endDate')} />
                        </div> */}
                </div>
                <div className="form__group">
                    <BasicFieldCheckbox field={generateForm.$('overrideManuallyUpdated')}/>Override Manually
                </div>
            </div>
            <div className="modal__footer">
                <BaasicFormControls 
                    form={generateForm} 
                    onSubmit={generateForm.onSubmit} 
                    disabled={generateForm.submitting || generateForm.validating} 
                    label="Save" 
                    className='btn btn--med btn--primary'
                />
            </div>
        </form>
    )
}

GenerateTemplate.propTypes = {
    generateStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(GenerateTemplate);
